import { render } from "./enterpriseDetail.vue?vue&type=template&id=250b3e8e&scoped=true"
import script from "./enterpriseDetail.vue?vue&type=script&lang=js"
export * from "./enterpriseDetail.vue?vue&type=script&lang=js"

import "./enterpriseDetail.vue?vue&type=style&index=0&id=250b3e8e&scoped=true&lang=css"

import exportComponent from "D:\\code\\vue\\gaoxinTech\\gaoxin_tech1\\gaoxintech\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-250b3e8e"]])

export default __exports__